import React, { useState } from "react";
import Carousel from "react-bootstrap/Carousel";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import styled, { css } from "styled-components";
import { ArsenalCard } from "../ui/ArsenalCard";
import ball_icon_blue from "../../images/speechsheet/ball_icon_blue.svg";
import add_spec from "../../images/Add_Spec_Sheet_Icon.png";
import { useNavigate } from "react-router-dom";
import moment from "moment";

const BorderContainer = styled.div`
  width: 100%;
  width: -webkit-fill-available;
  height: 180px;
  margin-top: 1vh;
  background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
  border: 1px solid var(--unnamed-color-d4d4d5);
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #d4d4d5;
  border-radius: 4px;
  opacity: 1;
  display: flex;
  align-content: center;
  justify-content: center;
  align-items: center;
`;

const nameStyle = {
  fontSize: "11px",
  fontWeight: 600,
  letterSpacing: "0.8px",
  color: "#6b7280",
  textTransform: "uppercase",
  marginLeft: "0",
};

const Button = styled.button`
  background: #00becc 0% 0% no-repeat padding-box;
  border-color: #00becc;
  border-radius: 4px;
  margin-top: 7px;
  opacity: 1;
  width: 145px;
  height: 48px;
  font-weight: 500;

  &:hover {
    background: #00187e;
    border-color: #00187e;
    color: #ffffff;
  }
`;

const ButtonCompleteArsenal = styled.button`
  background: #ffffff 0% 0% no-repeat padding-box;
  border-color: #00297a;
  border-radius: 10px;
  margin-top: 7px;
  margin-left: 195px;
  opacity: 1;
  width: 180px;
  height: 48px;
  font-weight: 500;

  &:hover {
    background: #00187e;
    border-color: #00187e;
    color: #ffffff;
  }
`;

const ButtonAddBall = styled.button`
  background: #00297a 0% 0% no-repeat padding-box;
  border-color: #00297a;
  border-radius: 10px;
  margin-left: 40px;
  opacity: 1;
  width: 150px;
  height: 48px;
  font-weight: 500;

  &:hover {
    background: #00187e;
    border-color: #00187e;
    color: #ffffff;
  }
`;

const DescriptionText = styled.button`
  font-size: ${(props) => (props.title === true ? "16px" : "8px")};
  background: transparent;
  border-color: #00297a;
  border-radius: 10px;
  letter-spacing: 0px;
  height: 48px;
  width: 280px;
  opacity: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${(props) => (props.title === true ? "#00187E" : "inherit")};
  margin: 22px 0 22px 3px;
  font-weight: ${(props) => (props.title === true ? "700" : "300")};
`;

const ballLogoStyle = {
  width: "17px",
  height: "20px",
  padding: "0",
  margin: "0 7px 0 0",
};
const textStylesCompleteArsenal = {
  width: "17px",
  height: "20px",
  borderRadius: "10px",
  borderColor: "#00297a",
};

const logoStyle = {
  width: "17px",
  height: "16px",
  padding: "0",
  margin: "0 5px 0 0",
  cursosor: "pointer",
  fontSize: "12px",
};

const textStyles = {
  color: "#00197B",
  background: "transparent",
  border: "transparent",
  letterSpacing: "0.07px",
  fontSize: "12px",
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  order: 5,
  marginRight: "5px",
};

export const CarouselArsenal = ({
  balls_drilled,
  ballSelect,
  userId,
  arsenal_layout_style,
  ballAddNew,
  isReadOnly,
  is2Hander,
  isPortrait,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const bowlerID = params.bowlerID;

  const [index, setIndex] = useState(0);
  const [arsenal, setArsenal] = useState(balls_drilled);

  const handleCreateBall = () => {
    ballAddNew({});
  };

  const CarouselContainer = styled.div`
    width: 100%;
    max-width: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-start;
    align-content: flex-start;
    gap: 10px 0;
    height: 95%;
    padding-bottom: 50px;
    padding-left: 3px;
    padding-right: 3px;

    @media only screen and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 1.5) {
      height: auto;
      overflow: visible;
    }

    @media only screen and (orientation: portrait) {
      height: auto;
      overflow: visible;
    }
  `;

  const handleUserNavigate = () => {
    navigate("/arsenal/" + bowlerID);
  };

  return (
    <>
      {arsenal?.length >= 1 ? (
        <>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              backgroundColor: "transparent",
              width: "100%",
              height: "auto",
              marginBottom: "12px",
              paddingBottom: "0px",
            }}
          >
            <span style={nameStyle}>{t("form.label.arsenal")}</span>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                flexDirection: "row",
              }}
            >
              <button
                style={{
                  marginRight: "10%",
                  color: "#00187e",
                  backgroundColor: "transparent",
                  border: "none",
                }}
                onClick={handleUserNavigate}
              >
                <img
                  style={ballLogoStyle}
                  src={ball_icon_blue}
                  alt="ball logo style"
                />
                <span style={textStyles}>{t("View All")}</span>
              </button>
              <button
                style={{
                  marginRight: "10%",
                  color: "#00187e",
                  backgroundColor: "transparent",
                  border: "none",
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                }}
                onClick={handleCreateBall}
              >
                <img style={logoStyle} src={add_spec} alt="ball logo style" />
                <span style={textStyles}>{t("form.label.add")}</span>
              </button>
            </div>
          </div>
          <CarouselContainer
            style={{
              marginTop: "0px", // Adjust top margin
              paddingTop: "0px", // Adjust top padding
            }}
          >
            {arsenal
              ?.filter((arsenal) => arsenal.enable === true)
              .sort((a, b) =>
                moment(a.date_drilled).isAfter(moment(b.date_drilled)) ? -1 : 1
              )
              .map((arsenal, index) => (
                <ArsenalCard
                  name={`${arsenal.manufacturer || ""} ${
                    arsenal.ball_name || ""
                  }`}
                  ball_enable={arsenal.enable}
                  serial_number={arsenal.serial_number}
                  layout={arsenal.layout}
                  layout_type={arsenal.layout_type}
                  arsenal_layout_style={arsenal_layout_style}
                  surface_preparation={arsenal.surface_preparation}
                  date={arsenal.date_drilled || arsenal.updated_at}
                  userId={userId}
                  photo={arsenal.photo}
                  bowlerID={bowlerID}
                  id={arsenal.id}
                  view="two"
                  ball={arsenal}
                  ballSelect={ballSelect}
                />
              ))}
          </CarouselContainer>
        </>
      ) : (
        <BorderContainer>
          {!isReadOnly && (
            <Button className="btn btn-primary" onClick={handleCreateBall}>
              {t("form.label.add_ball")}
            </Button>
          )}
        </BorderContainer>
      )}
    </>
  );
};
